import React, { useState } from 'react';
import { useLayout } from '../../../context/LayoutContext';
import '../../../assets/scss/components/wssp/SearchBar.scss';
import { useWhatsApp } from '../../../context/WhatsAppContext';

const SearchBar = () => {
  const { theme } = useLayout();
  const { searchMessages } = useWhatsApp();
  const [query, setQuery] = useState('');
  
  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    searchMessages(value);
  };
  
  const handleClear = () => {
    setQuery('');
    searchMessages('');
  };
  
  return (
    <div className={`GM__${theme}-wssp-search-bar`}>
      <div className={`GM__${theme}-wssp-search-input`}>
        <span className={`GM__${theme}-wssp-search-icon`}>🔍</span>
        <input
          type="text"
          placeholder="Buscar o iniciar un nuevo chat"
          value={query}
          onChange={handleChange}
          className={`GM__${theme}-wssp-search-field`}
        />
        {query && (
          <button 
            className={`GM__${theme}-wssp-search-clear`} 
            onClick={handleClear}
          >
            ✖
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;